:host {
  @include cms-components-host-defaults;
}

.section {
  margin-bottom: var(--cms-components-mb);
}

.section-inner {
  --cms-grid-padding: var(--cms-spacing-075) var(--cms-spacing-100) 0 var(--cms-spacing-100);
  display: grid;
  gap: var(--cms-grid-gap);
  height: var(--cms-grid-row-height);
  max-width: calc(var(--cms-container-max-width) - var(--cms-spacing-200));
  grid-template-columns: var(--cms-grid-template-columns);
  margin: auto;
  padding: var(--cms-grid-padding);
}

.container {
  grid-area: var(--cms-default-grid-area);
  position: relative;
}

.wrapper {
  margin: 1rem;
  padding: var(--cms-spacing-100);
  padding-bottom: var(--cms-spacing-300);
}

.wrapper>* {
  --cms-default-grid-area: auto / auto / auto / span 12;
  grid-area: var(--cms-default-grid-area);
}

.title-wrapper {
  position: relative;
  top: -42px;
  left: -24px;
}

.image-wrapper {
  justify-self: center;
}

.content-wrapper {
  position: inherit;
}

.image-wrapper,
.content-wrapper {
  color: var(--cms-semanticColors-base-strong-text);
}

.cta {
  width: 100%;
  --cms-theme-border-color: var(--cms-semanticColors-transparency-strong-border);
  --cms-theme-text-color: var(--cms-semanticColors-transparency-strong-textOnBackground)
}

.shop-link {
  text-transform: uppercase;
  text-decoration: none;
  width: 100%;
  cursor: pointer;
}

.title {
  color: var(--cms-semanticColors-primary-textOnBackground);
  // padding-top: 0.25rem;
  // padding-bottom: 0.25rem;
  // padding-left: 0.75rem;
  // padding-right: 0.75rem;
  padding: var(--cms-spacing-025) var(--cms-spacing-075);
  background-color: var(--cms-semanticColors-primary-background);
  font-size: var(--cms-font-size-112);
  line-height: var(--cms-line-height-133);
  font-weight: var(--cms-base-font-weight-700);
  font-family: var(--cms-brandfont1);
  display: inline-block;
}

.article-image {
  border-style: none;
  height: auto;
  max-width: 100%;
  vertical-align: middle;
}

.article-name {
  margin-bottom: var(--cms-spacing-050);
  // font-size: 1.25rem;
  // line-height: 1.1;
  // font-family: var(--cms-brandfont2);
  @include label-font-125;
}

.rating {
  --cms-theme-text-color: var(--cms-semanticColors-base-strong-text)
}

.energy-efficiency-data-producthighlight {
  margin-bottom: var(--cms-spacing-075);
}

.shop-link-wrapper {
  padding-left: 0;
  padding-right: 0;
  flex: 0 0 100%;
  max-width: 100%;
}

/* Enable clickthrough for hidden link */
.content-wrapper .article-detail-link:after {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  display: block;
  z-index: 1;
  position: absolute;
  pointer-events: auto;
  cursor: pointer;
}

.content-wrapper .energy-data-link,
.content-wrapper cms-button,
.content-wrapper cms-energy-label {
  position: relative;
  z-index: 5;
}

.eek-wrapper {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}

.energy-label-wrapper {
  max-width: 100%;
}

@media (min-width: 768px) {
  .container {
    --cms-default-grid-area: auto / 3 / auto / span 8;
  }

  .content-wrapper,
  .image-wrapper {
    --cms-default-grid-area: auto / auto / auto / span 6;
  }

  .image-wrapper {
    margin-bottom: 0 !important;
  }
}